<template>
    <div>
        <edition-input v-model="form.edition"
                       :errors="errors.edition"
                       :required="true"/>
        <div class="images">
            <div class="box__header">
                <span class="box__header--text">Lewa kolumna</span>
            </div>
            <el-form-item label="Tytuł"
                          :error="errors[addLanguageSuffix('left_title')]">
                <el-input v-model="form[addLanguageSuffix('left_title')]"/>
            </el-form-item>
            <el-form-item label="Kategoria"
                          :error="errors['left_category']">
                <el-select filterable
                           v-model="form.left_category"
                           placeholder="Kategoria">
                    <el-option v-for="category in categories"
                               :label="category.name_pl"
                               :key="category.id"
                               :value="category.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Nazwa przycisku"
                          :error="errors[addLanguageSuffix('left_button_title')]">
                <el-input v-model="form[addLanguageSuffix('left_button_title')]">
                </el-input>
            </el-form-item>
            <link-component v-model="form.left_link"
                            :errors="errors.left_link"/>
        </div>
        <div class="images">
            <div class="box__header">
                <span class="box__header--text">Prawa kolumna</span>
            </div>
            <el-form-item label="Tytuł"
                          :error="errors[addLanguageSuffix('right_title')]">
                <el-input v-model="form[addLanguageSuffix('right_title')]"/>
            </el-form-item>
            <el-form-item label="Kategoria"
                          :error="errors['right_category']">
                <el-select filterable
                           v-model="form.right_category"
                           placeholder="Kategoria">
                    <el-option v-for="category in categories"
                               :label="category.name_pl"
                               :key="category.id"
                               :value="category.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Nazwa przycisku"
                          :error="errors[addLanguageSuffix('right_button_title')]">
                <el-input v-model="form[addLanguageSuffix('right_button_title')]">
                </el-input>
            </el-form-item>
            <link-component v-model="form.right_link"
                            :errors="errors.right_link"/>
        </div>
    </div>
</template>
<script>
    import {Tag, StandCategory} from '@/api'
    import EditionInput from '@/components/EditionInput'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                categories: []
            }
        },
        mounted () {
            StandCategory.fetch().then(response => {
                this.categories = response.data
            })
        },
        components: {
            EditionInput
        }
    }
</script>
<style lang="scss" scoped>
    .collapse {
        padding: 0 20px;
        /*margin-bottom: 22px;*/
    }

    .collapse-header {
        display: flex;
        justify-content: space-between;
    }

    .box {
        &__header {
            margin: 20px 0;
        }
    }

</style>


// WEBPACK FOOTER //
// FoodVendorsWidget.vue?eda050f0